import { h, Component } from 'preact';
import { track } from 'utils/tracking';
import { condClass } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';

import s from 'components/shared/embedMode/scrollArrows.sss';

export default class ScrollArrows extends Component {

	/**
	 * Life Cycle
	 */


	constructor(props) {
		super(props);
		this.$container = typeof document !== 'undefined' && document.body;


		this.state = {
			scrollAtTop: false,
			scrollAtBottom: false
		};

		if (this.$container) {
			window.addEventListener('scroll', this.scrollHandler);

			this.state.scrollAtTop = this.$container.scrollTop === 0;
			this.state.scrollAtBottom = this.$container.scrollTop === this.$container.scrollHeight;

		}

	}

	componentWillUnmount() {
		// Clean up events
		window.removeEventListener('scroll', this.scrollHandler);
	}



	/**
	 * Event Handlers
	 */

	scrollHandler = () => {
		const isAtTop = this.$container.scrollTop === 0;
		const isAtBottom = this.$container.scrollTop === this.$container.scrollHeight - window.innerHeight;

		if (isAtTop !== this.state.scrollAtTop) {
			// Update top value
			this.setState({scrollAtTop: isAtTop});
		}

		if (isAtBottom !== this.state.scrollAtBottom) {
			// Update bottom value
			this.setState({scrollAtBottom: isAtBottom});
		}
	}

	scrollUp = () => {
		// grab all of the theaters from the list
		const theaters = document.querySelectorAll('.theaterTheater');

		track({a: 'embed_scroll_up'});

		let theaterScrollId;
		let newScrollPos = 0;

		[].forEach.call(theaters, (theater, id)=>{
			// Find the theater that is closest to filling an entire new screen of theaters by scrolling up
			// Substract the height of the fixed buttons at the bottom
			if (theater.getBoundingClientRect().top + window.innerHeight - 60 < 0) {
				theaterScrollId = id + 1;
				return true;
			}
		});

		let theaterToScroll = theaters[theaterScrollId];
		if (theaterToScroll) {
			// Substract 20 to give the button some more space
			newScrollPos = theaterToScroll.getBoundingClientRect().top + this.$container.scrollTop - 20;
		}

		smoothScrollTo(this.$container, newScrollPos, 800);

	}

	scrollDown = () => {
		// grab all of the theaters from the list
		const theaters = document.querySelectorAll('.theaterTheater');

		track({a: 'embed_scroll_down'});

		let theaterScrollId;
		let newScrollPos;

		[].find.call(theaters, (theater, id)=>{
			// Find the first theater that is outside of the viewport
			// Substract the height of the fixed buttons at the bottom
			if (theater.getBoundingClientRect().top - window.innerHeight + 60 >= 0) {

				// Scroll to the last visibile theater
				// it might already be hidden by the fixed arrow buttons
				theaterScrollId = id -1;
				return true;
			}
		});

		let theaterToScroll = theaters[theaterScrollId];

		if (theaterToScroll) {
			// Substract 50 to give the button some more space
			newScrollPos = theaterToScroll.getBoundingClientRect().top + this.$container.scrollTop - 50;
		} else {
			// If all theaters are already visible, then just scroll 80%
			newScrollPos = this.$container.scrollTop + (window.innerHeight * .8);

		}


		smoothScrollTo(this.$container, newScrollPos, 800);

	}

	/**
	 * Render
	 */

	render() {
		return (
			<div class={s.container}>
				<button class={s.btnUp + condClass(this.state.scrollAtTop, s.btnInactive)} onClick={this.scrollUp}/>
				<button class={s.btnDown  + condClass(this.state.scrollAtBottom, s.btnInactive)} onClick={this.scrollDown} />
			</div>
		);
	}
}
